import router from "../router"
import * as homeApi from '../api/index'
export function getOut(){

	localStorage.removeItem('token')
	localStorage.removeItem('userList')
	router.replace({ path: "/login" });
	window.location.reload();
}
export function checkWxLogin(){
	// homeApi.getWithdrawAppIdForKf({

	// }).then(res => {
 //    console.log(res)
 //    returnwindow.location.href
		let url = encodeURIComponent('https:www.doudshou.com')
		let appid = 'wx5c3246e6d88bd66d'
    const { href } = router.resolve({
      path: '/wx_login'
    });
		let wxurl = 'https://open.weixin.qq.com/connect/qrconnect?appid=' + appid + '&redirect_uri='+url+'&response_type=code&scope=snsapi_login&state=#wechat_redirect'

		// window.location.href = wxurl
		window.open(href, "TencentLogin", "width=500,height=400,menubar=0,scrollbars=1, resizable=1,status=1,titlebar=0,toolbar=0,location=1")
	// })
}



// WEBPACK FOOTER //
// ./src/utils/index.js